import { StatusCadastroEnum } from "../enum";

export class CRMResposta {
    id: number;
    descricao: string;
    tipo: number;
    statusCadastro: StatusCadastroEnum = StatusCadastroEnum.Ativo;
}